import { computed } from 'mobx';
import { observer } from 'mobx-react';
import { autoinject, bind, CardItem, inject, StatusCard } from 'Mri.Web.Common';
import * as React from 'react';
import { WeatherStore } from '../../Weather/WeatherStore';
import { ActiveDisplay } from '../ActiveDisplay';

export interface IDisplayTemperaturesCardProps {
    readonly display: ActiveDisplay;
    readonly loading?: boolean;
    readonly statusPoll?: Mri.DisplayStatuses.DisplayStatusPoll;
}

@autoinject
@observer
export class DisplayTemperaturesCard extends React.Component<IDisplayTemperaturesCardProps> {
    public render() {
        const { statusPoll } = this.props;

        const ambientTemperature =
            this.findSensor('Ambient Temperature')?.floatValue || this.findSensor('Ambient Temperature')?.doubleValue;
        const processorTemperature =
            this.findSensor('Processor Board Temperature')?.floatValue ||
            this.findSensor('Processor Board Temperature')?.doubleValue;

        return (
            <StatusCard title="Temperatures" iconContainer="px-0" loading={this.props.loading}>
                {!this.displayWeather && !!ambientTemperature && (
                    <CardItem label="Ambient Temperature" value={ambientTemperature.toString() + ' ℃'} />
                )}

                {!!statusPoll?.environmentalStatus?.closedLoopTemp && (
                    <CardItem
                        label="Closed Loop Air Temperature"
                        value={statusPoll.environmentalStatus.closedLoopTemp + ' ℃'}
                    />
                )}

                {!!processorTemperature && (
                    <CardItem label="Processor Board Temperature" value={processorTemperature.toString() + ' ℃'} />
                )}

                {!!statusPoll?.power?.avgTemperature && (
                    <CardItem
                        label="Avg Power Supply Temp"
                        value={statusPoll.power.avgTemperature.toFixed(2).toString() + ' ℃'}
                    />
                )}

                {statusPoll?.backlights?.map((b, idx) => (
                    <div key={idx}>
                        {!!b.avgTemperature && (
                            <CardItem
                                label={b.name ? `${b.name} Backlight Temp` : `Backlight ${idx + 1} Temp`}
                                value={b.avgTemperature.toFixed(2).toString() + ' ℃'}
                            />
                        )}
                    </div>
                ))}
            </StatusCard>
        );
    }

    @bind
    private findSensor(name: string) {
        if (this.props.statusPoll?.sensors) {
            const measurement = this.props.statusPoll.sensors.find(s => s.name == name);
            return measurement;
        }
    }

    @computed
    private get displayWeather() {
        return this.weatherStore.weathers.get(this.props.display.serialNumber);
    }

    @inject
    private weatherStore!: WeatherStore;
}
